// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__37vzx","colMaxWidth":"Table_colMaxWidth__3Ev8d"};